export function useAPI() {
    const config = useRuntimeConfig()
    const PUBLIC_API_URL = `${config.public.apiHost}/v1/public`
    const API_URL = `${config.public.apiHost}/v1/`

    const fetchData = async <T>(url: string): Promise<T> => {
        const { data, error } = await useFetch(url)

        if (error.value) {
            // Ignore aborted requests (e.g. navigation during fetch on Safari iOS)
            if (error.value.name === 'AbortError' || error.value.statusCode === 0) {
                return data.value as T
            }

            console.log(`Error calling ${url}`, error, error.value)
            showError({
                statusCode: error.value.statusCode || 404,
                message: `Error calling ${url}`
            })
        }

        return data.value as T
    }

    const postData = async (url: string, data: any): Promise<any> => {
        const userData = data
        try {
            let response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(userData)
            })

            let res = await response.json()

            return res
        } catch (error) {
            console.error('Error posting user data:', error)
        }
    }

    return { PUBLIC_API_URL, API_URL, fetchData, postData }
}
